import { CompoundSearchCriterion } from './compound-search-filters';

export function normalizeCompoundOperators(query: CompoundSearchCriterion[]) {
  // This function is used to normalize the compound operators in the query.
  // We used to have an 'AND NOT' operator, but it was replaced by two separate 'AND' and 'NOT' operators.
  // This function ensures that the query which comes from scisors or localstorage is normalized and compatible with the new operator syntax.
  return query.reduce<CompoundSearchCriterion[]>((acc, criterion) => {
    if (criterion.type === 'operator' && criterion.value === 'AND NOT') {
      return [...acc, { type: 'operator', value: 'AND' }, { type: 'operator', value: 'NOT' }];
    }

    return [...acc, criterion];
  }, []);
}
